

import { useTheme } from "@mui/material/styles";
import { SVGProps } from "react";

interface SupportIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export default function SupportIcon({ color, ...props }: SupportIconProps) {
  const theme = useTheme();
  
  // 如果没有指定颜色，使用当前主题的文本颜色
  const iconColor = color || theme.palette.mode === "dark" ? "#161A1E" : "#F2F2F2";

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none"
      {...props}
    >
      <path 
        d="M3 10.9999H6C6.53043 10.9999 7.03914 11.2106 7.41421 11.5857C7.78929 11.9607 8 12.4694 8 12.9999V15.9999C8 16.5303 7.78929 17.039 7.41421 17.4141C7.03914 17.7892 6.53043 17.9999 6 17.9999H5C4.46957 17.9999 3.96086 17.7892 3.58579 17.4141C3.21071 17.039 3 16.5303 3 15.9999V10.9999ZM3 10.9999C3 9.81798 3.23279 8.64766 3.68508 7.55573C4.13738 6.4638 4.80031 5.47164 5.63604 4.63592C6.47177 3.80019 7.46392 3.13725 8.55585 2.68496C9.64778 2.23267 10.8181 1.99988 12 1.99988C13.1819 1.99988 14.3522 2.23267 15.4442 2.68496C16.5361 3.13725 17.5282 3.80019 18.364 4.63592C19.1997 5.47164 19.8626 6.4638 20.3149 7.55573C20.7672 8.64766 21 9.81798 21 10.9999M21 10.9999V15.9999C21 16.5303 20.7893 17.039 20.4142 17.4141C20.0391 17.7892 19.5304 17.9999 19 17.9999H18C17.4696 17.9999 16.9609 17.7892 16.5858 17.4141C16.2107 17.039 16 16.5303 16 15.9999V12.9999C16 12.4694 16.2107 11.9607 16.5858 11.5857C16.9609 11.2106 17.4696 10.9999 18 10.9999H21Z" 
        stroke={iconColor} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M21 16.0001V18.0001C21 19.061 20.5786 20.0784 19.8284 20.8285C19.0783 21.5787 18.0609 22.0001 17 22.0001H12" 
        stroke={iconColor} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
}